import { imageCdnPath } from './vd-image-cdn-path'

/**
 * Filter for retrieving an image at a given size for a given product.
 *
 * @function
 *
 * @param  {Product} product
 *         The product to get the image for.
 *
 * @param  {String} [size='sm']
 *         The size of the image to be returned. Defaults to square medium (sm) 100px x 100px
 *
 * @param  {Boolean} [false]
 *         Should this be regarded as a variant?
 *
 * @return {String} The product's image path
 */
export function productImagePath(product, size = 'sm', isVariant = false) {
  if (!product) {
    return imageCdnPath('products/placeholder.svg')
  }

  const images =
    product[isVariant || product.variant_parent_id ? 'skuImages' : 'images']
  const mainProductImage = images && images[0]
  const requestedImageSize =
    mainProductImage && mainProductImage.sizes && mainProductImage.sizes[size]

  return (
    requestedImageSize ||
    (mainProductImage && mainProductImage.url) ||
    product.image_url ||
    imageCdnPath('products/placeholder.svg')
  )
}
